'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Navigation = require('../components/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _UIApplication = require('UIComponents/app/UIApplication');

var _UIApplication2 = _interopRequireDefault(_UIApplication);

var _reactRedux = require('react-redux');

var _UITable = require('UIComponents/table/UITable');

var _UITable2 = _interopRequireDefault(_UITable);

var _UIDashboardPage = require('UIComponents/page/UIDashboardPage');

var _UIDashboardPage2 = _interopRequireDefault(_UIDashboardPage);

var _UIHeader = require('UIComponents/layout/UIHeader');

var _UIHeader2 = _interopRequireDefault(_UIHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToyList = function (_Component) {
  _inherits(ToyList, _Component);

  function ToyList() {
    _classCallCheck(this, ToyList);

    return _possibleConstructorReturn(this, (ToyList.__proto__ || Object.getPrototypeOf(ToyList)).apply(this, arguments));
  }

  _createClass(ToyList, [{
    key: 'renderRows',
    value: function renderRows() {
      return this.props.list.map(function (company) {
        return _react2.default.createElement(
          'tr',
          { key: company.id },
          _react2.default.createElement(
            'td',
            null,
            company.rank
          ),
          _react2.default.createElement(
            'td',
            null,
            company.name
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              'a',
              { href: '//' + company.website },
              company.website
            )
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var headerComponent = _react2.default.createElement(_UIHeader2.default, { title: 'Toy List' });
      return _react2.default.createElement(
        _UIApplication2.default,
        { name: 'growthhub-ui' },
        _react2.default.createElement(_Navigation2.default, null),
        _react2.default.createElement(
          _UIDashboardPage2.default,
          { headerComponent: headerComponent },
          _react2.default.createElement(
            _UITable2.default,
            null,
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'Rank'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Company Name'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'Site'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              this.renderRows()
            )
          )
        )
      );
    }
  }]);

  return ToyList;
}(_react.Component);

ToyList.propTypes = {
  list: _react.PropTypes.array
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    list: state.toys.list || []
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ToyList);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/pages/ToyList.js
// module id = 220
// module chunks = 171